import { BCol, BIcon, BRow, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import moment from 'moment'
import React from 'react'

import { intl, IntlInterface } from '../../hoc'
import { LOGOUT_TIMEOUT, Routes } from '../../constants'
import { modalDialogActions } from '../../redux'
import { SHOW_INACTIVITY, SHOW_INACTIVITY_LOGOUT } from '../../constants/modals'
import { PageControlButtons } from '../index'
import messages from '../../i18n'
import storage from '../../utils/localStorage'

import styles from './styles.module.css'

interface Props extends IntlInterface {
  hideModalDialog: any
  showModalDialog: any
  push: any
}

interface State {
  timer: number
}

export class InactivityDialog extends React.Component<Props, State> {
  state: State = {
    timer: LOGOUT_TIMEOUT,
  }

  componentDidMount(): void {
    this.handle = setInterval(() => {
      this.deductTime()
    }, 1000)
  }

  componentWillUnmount(): void {
    clearInterval(this.handle)
  }

  deductTime = () => {
    this.setState(
      state => ({
        ...state,
        timer: state.timer - 1000,
      }),
      () => {
        if (this.state.timer <= 0) {
          this.hideDialog()
          this.props.showModalDialog(SHOW_INACTIVITY_LOGOUT)
        }
      }
    )
  }

  hideDialog = () => {
    clearInterval(this.handle)
    this.props.hideModalDialog(SHOW_INACTIVITY.id)
  }

  exit = () => {
    this.hideDialog()
    this.props.push(Routes.EXIT)
  }

  handle: any

  render() {
    return (
      <>
        <BRow>
          <BCol theme="text-center">
            <BIcon name="clock" theme={styles.clockSize} />
            <BTitle type="h2" center>
              {this.props.translate(messages.inactivityDialog.title)}
            </BTitle>
            <BTitle type="h2" theme="text-info">
              {moment(this.state.timer).format('mm:ss')}
            </BTitle>
            <BText>{this.props.translate(messages.inactivityDialog.subtitle)}</BText>
          </BCol>
        </BRow>

        <PageControlButtons
          secondaryAction={this.exit}
          secondaryMessage={messages.inactivityDialog.exit}
          onSubmit={() => {
            this.props.hideModalDialog(SHOW_INACTIVITY.id)
            storage.setItem('enableInactivityTimer', true)
          }}
          submitMessage={messages.inactivityDialog.close}
        />
      </>
    )
  }
}

export default compose(
  connect(null, {
    hideModalDialog: modalDialogActions.hideModalDialog,
    showModalDialog: modalDialogActions.showModalDialog,
    push,
  }),
  intl
)(InactivityDialog)
